// extracted by mini-css-extract-plugin
export var content = "focus-content-module--content--a967d";
export var contentNoImg = "focus-content-module--contentNoImg--9654f";
export var imgcContainer = "focus-content-module--imgcContainer--7d46e";
export var innerContainer = "focus-content-module--innerContainer--5647a";
export var innerContainerNoImg = "focus-content-module--innerContainerNoImg--44e58";
export var labelButton = "focus-content-module--labelButton--b5d60";
export var root = "focus-content-module--root--5b79c";
export var title = "focus-content-module--title--eaf03";